import React from 'react'
import ChargebackTemplate from '../ChargebacksTemplate/ChargebackTemplate'

const PendingChargeback = () => {
  return (
    <div>
      <ChargebackTemplate title='Pending' status="Pending"/>
    </div>
  )
}

export default PendingChargeback
